import React, { useState } from "react";
import { Flex, Box } from "rebass";
import { has, get, union, uniqBy, filter, find } from "lodash";

import { FormDataConsumer, useTranslate, useNotify } from "react-admin";
import { getPromotion } from "../../restClient";
import ProductOrderItems from "./ProductOrderItems";
// import AppBar from "@material-ui/core/AppBar"
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { TabPanel, a11yProps } from "./TabsContent";
import OrderInfoShow from "./OrderInfoShow";

const EditFormFields = (props) => {
  const translate = useTranslate();
  const notify = useNotify();
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const getPromotionById = (id) => {
    if (id) {
      getPromotion(id)
        .then((response) => response.json())
        .then((data) => {
          if (data && data !== null) {
            props.updateField("promotions", data);
          }
        })
        .catch((e) => {});
    }
  };
  const onAddOrderItem = (data) => {
    const { product, promotions, qty } = data;
    if (has(product, "id") && qty && qty > 0) {
      const orderItems = get(data, "items", []);
      const resultku = find(orderItems, function (o) {
        return o.product_id === product.id;
      });
      const newPromotions = promotions && promotions !== null ? promotions : {};
      const result = get(resultku, "result", {
        promotions: newPromotions,
        product_id: product.id,
      });
      const newItem = {
        result: {
          ...result,
          qty: qty,
          price: product.price,
          subtotal: qty * product.price,
        },
        product: product,
        product_id: product.id,
      };
      // console.log(newItem)
      const resultA = union([newItem], orderItems);
      // console.log(resultA)
      props.updateField("items", uniqBy(resultA, "product_id"));
      props.updateField("product", undefined);
      props.updateField("promotions", undefined);
      props.updateField("qty", undefined);
      setValue("");
      setSuggestions([]);
    } else {
      notify("resources.orders.messages.product_qty", "warning");
    }
  };
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onRemoveItem = (item, orderItems) => {
    const newData = filter(orderItems, function (o) {
      return o.product_id !== item.product_id;
    });
    props.updateField("items", newData);
  };
  const onEditItem = (item) => {
    props.updateField("product", item.product);
    props.updateField("promotions", item.result.promotions);
    props.updateField("qty", item.result.qty);
    setValue(item.product.packaging);
  };

  return (
    <Flex>
      <FormDataConsumer>
        {({ formData }) => (
          <Flex width={[1]} flexDirection={"column"}>
            <Box width={[1]} pb={[3]}>
              <OrderInfoShow {...props} translate={translate} isEdit={true} />
            </Box>

            <Tabs value={0} aria-label='Order items'>
              <Tab
                label={translate("resources.po.tabs.order_items")}
                {...a11yProps(0)}
              />
            </Tabs>
            <TabPanel value={0} index={0}>
              <ProductOrderItems
                translate={translate}
                getPromotionById={getPromotionById}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                value={value}
                setSuggestions={setSuggestions}
                suggestions={suggestions}
                setValue={setValue}
                formData={formData}
                onAddOrderItem={onAddOrderItem}
                onRemoveItem={onRemoveItem}
                onEditItem={onEditItem}
                isEdit={true}
                {...props}
              />
            </TabPanel>
          </Flex>
        )}
      </FormDataConsumer>
    </Flex>
  );
};

export default EditFormFields;
